import { api } from "../../api/client";

export function getSystems() {
  return api.get("/admin/systems");
}

export function createSystem(system) {
  return api.post("/admin/systems", system);
}

export function updateSystem(uuid, updatedFields) {
  return api.put(`/admin/systems/${uuid}`, updatedFields);
}

export function deleteSystem(uuid, sessionId) {
  return api.delete(`/admin/systems/${uuid}`, { data: { session_id: sessionId } });
}
